import { Flex, Spin } from "antd";
import React, { useEffect, useState } from "react";
import ConsultationService from "../../../../../../Services/ConsultationService";
import PatientService from "../../../../../../Services/PatientService";
import NoDataFound from "../../../../../../Assets/Images/Svg/nodatafound.svg";
import PrecriptionTable from "./PrecriptionTable";

function ViewPrescription({ selectedPatient, permissionData }) {
  const [prescriptionsList, setPrescriptionsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPatientDetails, setSelectedPatientDetails] = useState(null);
  const [age, setAge] = useState(null);

  useEffect(() => {
    fetchPatientDetails(selectedPatient?.patientId);
  }, []);

  useEffect(() => {
    const fetchPermittedData = async () => {
      await fetchPatientPermission();
    };
    fetchPermittedData();
  }, [selectedPatient, permissionData]);

  const fetchPatientDetails = async (Id) => {
    const payload = {
      patientId: Id,
    };
    try {
      const response = await PatientService.PatientListFilter(payload);
      setSelectedPatientDetails(response.data[0]);
      const dobData = response.data[0].dob;
      const dobYear = dobData?.split("/")[2];
      const currYear = new Date().getFullYear();
      if (dobYear) {
        const patientAge = currYear - Number(dobYear);
        setAge(patientAge);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const patientName = `${selectedPatientDetails?.salutation || ""} ${
    selectedPatientDetails?.firstName || ""
  } ${selectedPatientDetails?.lastName || ""}`.trim();

  const updatedPrescriptionsList = prescriptionsList.map((prescription) => ({
    ...prescription,
    patientName: patientName,
  }));

  const fetchPatientPermission = () => {
    if (permissionData?.prescription === "Y") {
      fetchAllPrescriptions(permissionData?.prescription);
    }
  };

  const fetchAllPrescriptions = async (permission) => {
    let payload = {
      // userId: (permission === null || permission === "N") ? selectedPatient?.userId : '',
      patientId: selectedPatient?.patientId,
      detailsYN: "Y",
    };
    setLoading(true);
    await ConsultationService.getPrescriptions(payload)
      .then((result) => {
        setPrescriptionsList(result.data);
      })
      .catch((error) => {
        console.error("Failed to fetch reports:", error);
        setPrescriptionsList([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="w-full">
      {loading ? (
        <div className="w-full flex items-center justify-center mt-[10%] bg-brand-White">
          <Flex align="center" gap="middle">
            <Spin size="large" tip="Loading" />
          </Flex>
        </div>
      ) : prescriptionsList && prescriptionsList.length > 0 ? (
        <>
          <PrecriptionTable
            data={updatedPrescriptionsList}
            selectedPatient={selectedPatient}
          />
        </>
      ) : (
        <div className="w-full flex justify-center items-center">
          <img
            src={NoDataFound}
            alt="No Data"
            style={{ height: "12rem", width: "19rem" }}
          />
        </div>
      )}
    </div>
  );
}

export default ViewPrescription;
